import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import type { UserRole } from '@/types';

interface ProtectedRouteProps {
    role: UserRole;
}

export default function ProtectedRoute({ role }: ProtectedRouteProps) {
    const { isLoggedIn, user } = useAuth();

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (user?.role !== role) {
        // Redirect to the correct dashboard for this user's actual role
        const roleRoutes: Record<string, string> = {
            'Admin': '/dashboard',
            'Case Manager': '/case-manager',
            'Mediator': '/mediator',
            'User': '/user',
        };
        const redirect = roleRoutes[user?.role ?? ''] ?? '/login';
        return <Navigate to={redirect} replace />;
    }

    return <Outlet />;
}
